import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { red } from '@material-ui/core/colors';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import store from '../../store/Store';
import './profile.scss';
import Logo from '../logo/Logo';
import requestLogin from '../../actions/loginActions';

type profileState = {
	login: {
		loggedIn
	},
	user: {
		id,
		title,
		name,
		lastName,
		gender,
		email,
		password
	}
}

type profileProps = {
	login: {
		loggedIn
	},
	user: {
		id,
		title,
		name,
		lastName,
		gender,
		email,
		password
	}
}

class Profile extends React.Component<profileProps, profileState> {

	handleChangeEmail = ((event) => {
		this.setState({ 
			"user": Object.assign(
				{},
				this.state.user,
				{
					email: event.target.value
				}
			)
		});
	})

	handleChangePassword = ((event) => {
		this.setState({
			"user": Object.assign(
				{},
				this.state.user,
				{
					password: event.target.value
				}
			)
		});
	})

	constructor(props) {
		super(props);

		this.state = {
			login: {
				loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
			},
			user: {
				id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
				title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
				name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
				lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
				gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
				email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
				password: store.getState().user && store.getState().user.password ? store.getState().user.password : ''
			}
		}

		this.handleChangeEmail = this.handleChangeEmail.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				login: {
					loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
				},
				user: {
					id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
					title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
					name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
					lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
					gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
					email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
					password: store.getState().user && store.getState().user.password ? store.getState().user.password : ''
				}
			})
		})
	}

	async putData() {
		await fetch(`http://localhost:3001/api/user/:id`, { 
			method: "PUT",
			mode: "cors",
			headers: {
			  'Accept': 'application/json',
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify({ 
				email: this.state.user.email || '',
				password: this.state.user.password || ''
			})
		})
		.then(res => res.json())
		.then((data) => {
			console.log(data);
			this.setState({ 
				user: data 
			});
		})
		.catch(console.log)
	}

  render() {
	  return (
	    <div className="Profile">
	    	<div className="Info">
	    		<div className="Info-Item">
	    			{this.state.user.id}
	    		</div>
	    		<div className="Info-Item">
	    			{this.state.user.title}
	    		</div>
	    		<div className="Info-Item">
	    			{this.state.user.name}
	    		</div>
	    		<div className="Info-Item">
	    			{this.state.user.lastName}
	    		</div>
	    		<div className="Info-Item">
	    			{this.state.user.gender}
	    		</div>
	    		<div className="Info-Item">
	    			{this.state.user.email}
	    		</div>
	    		<div className="Info-Item">
	    			{this.state.user.password}
	    		</div>
	    	</div>
	    </div>
	  );
  }
}

export default Profile;